<!DOCTYPE html>
<html [lang]="language">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/icofont/1.0.1/icofont.min.css">
</head>

<body class="bg-gray-50 font-sans" [ngClass]="{'dir-rtl': language === 'ar'}">
  <app-navbar [business]="business" [menuUrl]="menuUrl" [hasMultipleBranches]="hasMultipleBranches"
    [menuBranches]="menuBranches"></app-navbar>
  <!-- Slider -->
  <section *ngIf="business && business.sliders && business.sliders.length > 0" class="pt-0 pb-0" id="home">
    <div class="slider-bg">
      <ul class="slides">
        <li>
          <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr">
            <ng-template carouselSlide *ngFor="let slide of business.sliders">
              <div class="slide-img" [style.backgroundImage]="getSliderImageUrl(slide)">
                <div class="hero-text-wrap">
                  <div class="hero-text white-color">
                    <div class="container text-center">
                      <h1 class="title raleway-font">
                        {{ (language === 'ar' && slide.description_ar) ? slide.description_ar : slide.description ||
                        languageService.getTranslation('welcomeTo') }}
                      </h1>
                      <h2 class="white-color font-700">{{ (language === 'ar' && business.name_ar) ?
                        business.name_ar : business.name }}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </owl-carousel-o>
        </li>
      </ul>
    </div>
  </section>

  <!-- Services – Centered cards -->
  <section *ngIf="business && getServices().length > 0" class="py-16 bg-white" id="services">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <h1 class="text-3xl md:text-4xl font-bold text-teal-900">
          {{ languageService.getTranslation('whatWeOffer') }}
        </h1>
        <h2 class="text-xl md:text-2xl text-gray-600 mt-2">
          {{ languageService.getTranslation('atBusinessName', business) }}
        </h2>
      </div>
      <div class="flex justify-center">
        <div class="inline-flex flex-wrap justify-center gap-6 max-w-6xl w-full">
          <div *ngFor="let service of getServices()"
            class="service-card bg-gradient-to-br from-teal-50 to-purple-50 p-6 rounded-lg shadow-md text-center"
            style="width: 320px;">
            <div class="flex justify-center mb-4">
              <ng-container *ngIf="service.icon_url; else defaultIcon">
                <img [src]="getServiceIconUrl(service.icon_url)" alt="{{service.name}} Icon" class="service-icon">
              </ng-container>
              <ng-template #defaultIcon>
                <i class="fas fa-cogs text-3xl text-purple-500"></i>
              </ng-template>
            </div>
            <h5 class="text-lg font-semibold text-teal-900 mb-2">{{service.name}}</h5>
            <p class="text-gray-600">{{service.description}}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- About – Centered paragraph & cards -->
  <section *ngIf="business && (getAboutUs() || getPostalAddress() || business.social_urls?.work_hours)"
    class="py-16 bg-teal-50" id="about">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <h1 class="text-3xl md:text-4xl font-bold text-teal-900">
          {{ languageService.getTranslation('weAreBusinessName', business) }}
        </h1>
        <h2 class="text-xl md:text-2xl text-gray-600 mt-2">
          {{ languageService.getTranslation('aboutUs') }}
        </h2>
        <p *ngIf="getAboutUs()" class="mt-4 text-gray-600 max-w-3xl mx-auto text-center">
          {{getAboutUs()}}
        </p>
      </div>
      <div class="flex justify-center">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl w-full">
          <div *ngIf="getPostalAddress()" class="info-card bg-white p-4 rounded-lg shadow-md text-center">
            <h4 class="text-lg font-semibold text-teal-900">
              <i class="fas fa-map-marker-alt mr-2 text-purple-500"></i>{{getPostalAddress()}}
            </h4>
          </div>
          <div *ngIf="business.social_urls?.work_hours" class="info-card bg-white p-4 rounded-lg shadow-md text-center">
            <h4 class="text-lg font-semibold text-teal-900">
              <i class="fas fa-clock mr-2 text-purple-500"></i>{{business.social_urls?.work_hours}}
            </h4>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Contact – Centered info cards -->
  <section
    *ngIf="business && (getPostalAddress() || business.office_numbers?.length || business.email || business.social_urls?.support_email || business.social_urls?.deliveries?.length)"
    class="py-16 bg-white" id="contact">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <h1 class="text-3xl md:text-4xl font-bold text-teal-900">
          {{ languageService.getTranslation('justKeepInTouch') }}
        </h1>
        <h2 class="text-xl md:text-2xl text-gray-600 mt-2">
          {{ languageService.getTranslation('contactUsNow') }}
        </h2>
      </div>
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div
          *ngIf="getPostalAddress() || business.office_numbers?.length || business.social_urls?.support_email || business.social_urls?.deliveries?.length"
          class="space-y-6 flex justify-center">
          <div class="max-w-2xl w-full">
            <div *ngIf="getPostalAddress()" class="info-card bg-white p-4 rounded-lg shadow-md text-center">
              <h3 class="text-lg font-semibold text-teal-900">
                <i class="fas fa-map-marker-alt mr-2 text-purple-500"></i>
                {{ languageService.getTranslation('postalAddress') }}
              </h3>
              <p class="text-gray-600 mt-2" [ngClass]="{'text-right': language === 'ar'}">
                {{getPostalAddress()}}
              </p>
            </div>
            <div *ngIf="business.office_numbers?.length"
              class="info-card bg-white p-4 rounded-lg shadow-md text-center">
              <h3 class="text-lg font-semibold text-teal-900">
                <i class="fas fa-phone-alt mr-2 text-purple-500"></i>
                {{ languageService.getTranslation('officeNumber') }}
              </h3>
              <p *ngFor="let number of business.office_numbers" class="text-gray-600 mt-2"
                [ngClass]="{'text-right': language === 'ar'}">
                {{number}}
              </p>
            </div>
            <div *ngIf="business.social_urls?.support_email"
              class="info-card bg-white p-4 rounded-lg shadow-md text-center">
              <h3 class="text-lg font-semibold text-teal-900">
                <i class="fas fa-headset mr-2 text-purple-500"></i>
                {{ languageService.getTranslation('support') }}
              </h3>
              <p class="text-gray-600 mt-2" [ngClass]="{'text-right': language === 'ar'}">
                {{business.social_urls?.support_email}}
              </p>
            </div>
            <div *ngIf="business.social_urls?.deliveries?.length"
              class="info-card bg-white p-4 rounded-lg shadow-md text-center">
              <h3 class="text-lg font-semibold text-teal-900">
                <i class="fas fa-truck mr-2 text-purple-500"></i>
                {{ languageService.getTranslation('deliveryServices') }}
              </h3>
              <p *ngFor="let delivery of business.social_urls?.deliveries" class="text-gray-600 mt-2">
                <a [href]="delivery" target="_blank" rel="noopener noreferrer"
                  class="text-purple-500 hover:underline">{{delivery}}</a>
              </p>
            </div>
          </div>
        </div>
        <div [ngClass]="{
          'lg:col-span-1': (getPostalAddress() || business.office_numbers?.length || business.social_urls?.support_email || business.social_urls?.deliveries?.length),
          'lg:col-span-2 max-w-lg mx-auto': !(getPostalAddress() || business.office_numbers?.length || business.social_urls?.support_email || business.social_urls?.deliveries?.length)
        }" class="contact-card bg-white p-6 rounded-lg shadow-lg">
          <form (submit)="sendEmail($event)" class="space-y-6" #contactForm="ngForm">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4" [ngClass]="{'flex-row-reverse': language === 'ar'}">
              <div>
                <label for="user_name" class="sr-only">{{ languageService.getTranslation('name') }}</label>
                <input type="text" minlength="2" maxlength="15"
                  [class.border-red-500]="userName.invalid && userName.touched" name="user_name" id="user_name"
                  class="form-input w-full p-3 rounded-md focus:outline-none"
                  [placeholder]="languageService.getTranslation('name') + ' *'" [(ngModel)]="formData.user_name"
                  #userName="ngModel" required>
                <div *ngIf="userName.invalid && userName.touched" class="text-red-500 text-sm mt-1">
                  {{ languageService.getTranslation('name') }} is required.
                </div>
              </div>
              <div>
                <label for="user_email" class="sr-only">{{ languageService.getTranslation('email') }}</label>
                <input type="email" minlength="2" maxlength="35"
                  [class.border-red-500]="userEmail.invalid && userEmail.touched" name="user_email" id="user_email"
                  class="form-input w-full p-3 rounded-md focus:outline-none"
                  [placeholder]="languageService.getTranslation('email') + ' *'" [(ngModel)]="formData.user_email"
                  #userEmail="ngModel" required email>
                <div *ngIf="userEmail.invalid && userEmail.touched" class="text-red-500 text-sm mt-1">
                  A valid {{ languageService.getTranslation('email') }} is required.
                </div>
              </div>
            </div>
            <div>
              <label for="message" class="sr-only">{{ languageService.getTranslation('message') }}</label>
              <textarea name="message" [class.border-red-500]="userMessage.invalid && userMessage.touched" id="message"
                rows="5" class="form-textarea w-full p-3 rounded-md focus:outline-none"
                [placeholder]="languageService.getTranslation('message')" [(ngModel)]="formData.message"
                #userMessage="ngModel" required [ngClass]="{'text-right': language === 'ar'}"></textarea>
              <div *ngIf="userMessage.invalid && userMessage.touched" class="text-red-500 text-sm mt-1">
                {{ languageService.getTranslation('message') }} is required.
              </div>
            </div>
            <div class="text-left" [ngClass]="{'text-right': language === 'ar'}">
              <button type="submit"
                class="bg-purple-500 text-white px-6 py-3 rounded-md hover:bg-purple-600 transition-colors"
                [disabled]="contactForm.invalid">
                {{ languageService.getTranslation('sendMessage') }} <i class="fas fa-arrow-right ml-2"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>

  <app-footer [business]="business"></app-footer>
  <ngx-scrolltop></ngx-scrolltop>
</body>

</html>